export type RestaurantReservationSettings = {
  isEnabled: boolean
  minimumAdvanceMinutes: number
  maximumAdvanceDays: number
  slotIntervalMinutes: number
  reservationDurationMinutes: number
  minimumPartySize: number
  maximumPartySize: number
}

export type RestaurantReservationArea = {
  id: number
  name: string
  iconUrl: string
  capacity: number
  isActive: boolean
  displayOrder: number
}

export type PublicRestaurantReservationConfiguration = Pick<
  RestaurantReservationSettings,
  "isEnabled" | "minimumAdvanceMinutes" | "maximumAdvanceDays" | "minimumPartySize" | "maximumPartySize"
> & {
  areas: RestaurantReservationArea[]
}

export type RestaurantReservationSlot = {
  time: string
  isAvailable: boolean
}

export type RestaurantReservation = {
  id: number
  areaId: number
  areaName: string
  customerId: number
  customerName: string
  startsAt: string
  endsAt: string
  partySize: number
  notes?: string | null
  status: "Confirmed" | "Cancelled"
}

export const normalizeRestaurantReservation = (reservation: RestaurantReservation): RestaurantReservation => ({
  ...reservation,
  status: reservation.status === "Confirmed" || Number(reservation.status) === 0 ? "Confirmed" : "Cancelled",
})

export type RestaurantReservationManagement = {
  settings: RestaurantReservationSettings
  areas: RestaurantReservationArea[]
}

export type CreateRestaurantReservation = {
  areaId: number
  date: string
  time: string
  partySize: number
  notes?: string
}

export type SaveManagementRestaurantReservation = CreateRestaurantReservation & {
  id: number
  customerId: number
}
